module.exports = __webpack_public_path__ + "img/land-of-dreams.e196056e.jpg";